import { Inject, Injectable } from "@angular/core";
import { HttpService } from "../http.service";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";


@Injectable({
  providedIn: 'root'
})
export class ImportProducts extends HttpService<
  any,
  any
> {
   constructor(httpClient: HttpClient, @Inject('API_URL') apiUrl: string, @Inject('API_VERSION') apiVersion: string) {
       super(httpClient, apiUrl, apiVersion, 'bulk-import'); 
     }


     importSimpleProducts(formData: FormData) {
       return this.create(formData, 'product-simple/import');
     }

     updateImportSimpleProducts(formData: FormData) {
      return this.create(formData, 'product-simple/update');
     }

     importVariableProducts(formData: FormData) {
      return this.create(formData, 'product-variable/import');
      
     }
      importSeoCategoryKeywords(formData: FormData) {
      return this.create(formData, 'category/keywords/import');
     }

     updateImportVariableProducts(formData: FormData) {
      return this.create(formData, 'product-variable/smart-update');
     }



     importOffersProducts(formData: FormData) {
      return this.create(formData, 'offers/import');
     }

     importPriceProducts(formData: FormData) {
      return this.create(formData, 'price-update/import');
     }

      importVideosProducts(formData: FormData) {
      return this.create(formData, 'video-gallery/import');
     }

   

     /**
      * Sample sheets for IMPORTING new products. These carry the Department / Category /
      * Sub category columns with live, dependency-aware dropdowns sourced from the current
      * admin categories, so they are regenerated on every download. Do not swap these for the
      * `update-template` variants below - those are keyed by SKU and have no category columns.
      */
     downloadSimpleProductImportTemplate(): Observable<Blob> {
       return this.downloadFile('bulk-import/product-simple/template');
     }

     downloadVariableProductImportTemplate(): Observable<Blob> {
       return this.downloadFile('bulk-import/product-variable/template');
     }

     /** Sample sheets for UPDATING existing products (matched on SKU). */
     downloadSimpleProductTemplate(): Observable<Blob> {
       return this.downloadFile('bulk-import/product-simple/update-template');
     }

      downloadVariableProductTemplate(): Observable<Blob> {
       return this.downloadFile('bulk-import/product-variable/update-template');
      }

      downloadPricesTemplates(): Observable<Blob> {
       return this.downloadFile('bulk-import/price-update/template');
      }

        downloadOffersTemplates(): Observable<Blob> {
       return this.downloadFile('bulk-import/offers/template');
      }

       downloadVideosTemplates(): Observable<Blob> {
       return this.downloadFile('bulk-import/video-gallery/template');
      }


      exportSimpleProducts(): Observable<Blob> {
       return this.downloadFile('bulk-import/products/export');
      }

      exportVariableProducts(): Observable<Blob> {
       return this.downloadFile('bulk-import/product-variable/export');
      }
      exportCategoryKeywords(): Observable<Blob|any> {
       return this.downloadFile('bulk-import/category/keywords/export');
      }
      exportCategoryKeywordsTemplate(): Observable<Blob> {
       return this.downloadFile('bulk-import/category/keywords/template');
      }
    exportsynonyms(language: string): Observable<Blob> {
  return this.downloadFile(`bulk-import/synonyms/export?language=${language}`);
}

      downloadBrandsTeplate(): Observable<Blob> {
       return this.downloadFile('bulk-import/brand/export');
      }

      importBrands(formData: FormData) {
        return this.create(formData, 'brand');
      }

      downloadOrders(params: any): Observable<Blob> {
        return this.downloadFileWithParams('orders/export', params);
      }
    
    }